import React, { useState, useEffect, useCallback,useContext } from 'react';
import axios from 'axios';
import './AdjustableControl.css';
import ModalEnergy from './modal/ModalEnergy';
import { Context } from "../context";

const VitalityComponent = ({ idPerso, setVariable, token }) => {
  const { addAction } = useContext(Context);
  const ip = process.env.REACT_APP_IP;
  const [health, setHealth] = useState('Vie');
  const [energy, setEnergy] = useState('Energie');
  const [energies, setEnergies] = useState({});
  const [isOpenVie, setIsOpenVie] = useState(false);
  const [isOpenEnergie, setIsOpenEnergie] = useState(false);

  const fetchEnergies = useCallback(async () => {
    try {
      const response = await axios.get(`${ip}/energies/${idPerso}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
    });
      setEnergies(response.data);
      setVariable(response.data);
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }
  }, [idPerso, ip, setVariable]);

  useEffect(() => {
    fetchEnergies();
  }, [fetchEnergies]);
  
  useEffect(() => {
    addAction('fetchEnergies', fetchEnergies);
  }, [fetchEnergies, addAction]);
  const handleUpdate = useCallback(async (variable) => {
    try {
      await axios.put(`${ip}/energies/${variable.idVariable}`, {
        idVariable: variable.idVariable,
        nom: variable.nom,
        valeur: variable.valeur,
        idPersonnage: variable.idPersonnage,
        maximum: variable.maximum,
      },        {
        headers: {
          Authorization: `Bearer ${token}`,
        } 
      });
    } catch (error) {
      console.error('Erreur lors de la mise à jour des données :', error);
    }
  }, [ip]);

  const handleChange = useCallback(
    (e, type, name, max) => {
      
      const newValue = e.target.value;
      if (newValue > max) {
        return;
      }
      setEnergies((prevEnergies) => {
        const updatedEnergies = {
          ...prevEnergies,
          [type]: {
            ...prevEnergies[type],
            [name]: {
              ...prevEnergies[type][name],
              valeur: newValue,
            },
          },
        };
        handleUpdate(updatedEnergies[type][name]);
        return updatedEnergies;
      });
    },
    [handleUpdate]
  );

  const updateEnergy = useCallback(
    (type, nom, increment) => {
      setEnergies((prevEnergies) => {
        const updatedEnergies = { ...prevEnergies };
        const currentValue = updatedEnergies[type]?.[nom]?.valeur || 0;
        const maximum = updatedEnergies[type]?.[nom]?.maximum || 0;
        const newValue = increment ? Math.min(currentValue + 1, maximum) : Math.max(currentValue - 1, 0);

        updatedEnergies[type] = {
          ...updatedEnergies[type],
          [nom]: {
            ...updatedEnergies[type]?.[nom],
            valeur: newValue,
          },
        };

        handleUpdate(updatedEnergies[type][nom]);
        return updatedEnergies;
      });
    },
    [handleUpdate]
  );

  const iconVie = (value, max) =>{
    if(value <= max/4){
      return "4"
    } else if(value <= max/2){
      return "3"
    } else if(value <= (max/4)*3){
      return "2"
    } else {
      return "1"
    }
  }
  const iconNRJ = (value, max) =>{
    if(value <= max/"2"){
      return "3"
    } else if(value <= (max/3)*2){
      return "2"
    } else {
      return "1"
    }
  }

  return (
    <div className="containerEnergies">
      <div className="icon-container" onClick={() => setIsOpenVie(true)}>
        <span className="vitality-number number-vie">{energies['Vie']?.[health]?.valeur}</span>
        <img className='vitality_icon' src={`${process.env.PUBLIC_URL}/Images/VIE${iconVie(energies['Vie']?.[health]?.valeur,energies['Vie']?.[health]?.maximum)}.ico`} alt="icon" />
      </div>

      
      <div className="icon-container" onClick={() => setIsOpenEnergie(true)}>
        <span className="vitality-number number-nrj">{energies['Energie']?.[energy]?.valeur || 0}</span>

        <img className='vitality_icon' src={`${process.env.PUBLIC_URL}/Images/NRJ${iconNRJ(energies['Energie']?.[energy]?.valeur,energies['Energie']?.[energy]?.maximum)}.ico`} alt="icon" />
      </div>
      
      <ModalEnergy
        isOpen={isOpenVie}
        setOpen={setIsOpenVie}
        energies={energies}
        setHealth={setHealth}
        health={health}
        updateEnergy={updateEnergy}
        handleChange={handleChange}
        type={'Vie'}
        token={token}
      />
      <ModalEnergy
        isOpen={isOpenEnergie}
        setOpen={setIsOpenEnergie}
        energies={energies}
        setVariable={setEnergy}
        variable={energy}
        updateEnergy={updateEnergy}
        handleChange={handleChange}
        type={'Energie'}
        token={token}
      />
    </div>
  );
};

export default VitalityComponent;
